  import { put, call } from "redux-saga/effects";
  import {ActionConstants, ApiConstants} from "../constants";
  import axios from "axios";

  export default function* validateStep2Saga(data) {
    try {

      const result = yield call(validateStep2Api, data.payload);

      if (result == null || result.status !== 1) {
        yield put({
          type: ActionConstants.VALIDATE_STEP_2_FAILURE,
          payload: {
            result: result != null && result.data != null ? result.data : null,
            error: result != null && result.error != null ? result.error : null,
          },
        });
      } else {
        yield put({
          type: ActionConstants.VALIDATE_STEP_2_SUCCESS,
          payload: {
            result: result.data,
          },
        });
      }
    } catch (e) {
      yield put({
        type: ActionConstants.VALIDATE_STEP_2_FAILURE,
        payload: {
          result: e,
        },
      });
    }
  }

  const validateStep2Api = params => {
    const url = ApiConstants.URI_FE + ApiConstants.API_VALIDATE_STEP_2;
    return axios.post(url, params).then(response => response.data);
  };
